import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Pastikan token XSRF (CSRF) selalu disertakan agar tidak terkena 419.
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;
